import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {UserPasswordVerifyRequest} from "../payload-types/user-profile";
import {WebError} from "../web-error";

/**
 * #19351: POST {@link RevaApi.PATH_USER_PASSWORD_VERIFY} — checks the logged-in user's current password, so the
 * profile dialog only unlocks the new password / new e-mail input afterwards. 422 (wrong password, too many
 * attempts) and 503 are rethrown as the raw {@link WebError}, like `UserPasswordUpdateApiInterface`, so the
 * dialog can show reva-rest's own `error_de`.
 */
export class UserPasswordVerifyApiInterface extends SimpleApiInterface<object> {
    constructor(private readonly payload: UserPasswordVerifyRequest) {
        super();
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_USER_PASSWORD_VERIFY]);
    }

    protected buildPayload(): UserPasswordVerifyRequest {
        return this.payload;
    }

    protected executeInternal(executor: ApiExecutor, url: string, credentials: ApiCredentials): Promise<object> {
        return executor.fetchPOST(url, credentials, this.buildPayload());
    }

    protected override handleApiErrors(e: Error): object {
        if (e instanceof WebError && (e.status === 422 || e.status === 503)) {
            throw e;
        }
        return super.handleApiErrors(e);
    }
}
